
<div class="nav-bar">
  <ion-tabs class="nav-bar">
    <ion-tab-bar (ionTabBarChanged)="change($event)"  slot="bottom">
      
    <ion-tab-button tab="home">
        <div class="icon-wrapper">
          <ion-icon [src]="flag === 'home' ? '/assets/imgs/custom-svg/icon-home-fill.svg' : '/assets/imgs/custom-svg/icon-home-outline.svg'" [ngClass]="{'selected': flag === 'home', 'not-selected': flag !== 'home'}"></ion-icon>
        </div>
      </ion-tab-button>
      
      <ion-tab-button tab="chat-list">
        <div class="icon-wrapper">
          <ion-icon [src]="flag === 'chat-list' ? '/assets/imgs/custom-svg/icon-chat-filled.svg' : '/assets/imgs/custom-svg/icon-chat-outline.svg'" [ngClass]="{'selected': flag === 'chat-list', 'not-selected': flag !== 'chat-list'}"></ion-icon>
          <div class="notification" *ngIf="newCount > 0">{{ newCount > 99 ? '+99' : newCount}}</div>
        </div>
      </ion-tab-button>
      
      <ion-tab-button tab="super-like" >
        <div class="icon-wrapper">
          <ion-icon [src]="flag === 'super-like' ? '/assets/imgs/custom-svg/icon-star-filled.svg' : '/assets/imgs/custom-svg/icon-star-outline.svg'" 
            [ngClass]="{'selected': flag === 'super-like', 'not-selected': flag !== 'super-like'}">
          </ion-icon>
          <div class="notification" *ngIf="superLikeCount > 0">{{ superLikeCount > 99 ? '+99' : superLikeCount}}</div>
        </div>

      </ion-tab-button>
      <ion-tab-button tab="my-profile-display">
        <ion-icon [src]="flag === 'my-profile-display' ? '/assets/imgs/custom-svg/icon-user-filled.svg' : '/assets/imgs/custom-svg/icon-user-outline.svg'" [ngClass]="{'selected': flag === 'my-profile-display', 'not-selected': flag !== 'my-profile-display'}"></ion-icon>
      </ion-tab-button>

      <ion-tab-button tab="settings">
        <ion-icon [src]="flag === 'settings' ? '/assets/imgs/custom-svg/settings.svg' : '/assets/imgs/custom-svg/icon-settings-outline.svg'" [ngClass]="{'selected': flag === 'settings', 'not-selected': flag !== 'settings'}"></ion-icon>
      </ion-tab-button>
    </ion-tab-bar>

  </ion-tabs>
</div>